import { Button, TableItem } from 'components/atoms';
import { TopBar } from 'components/organisms';
import Table from 'components/organisms/table/Table';
import { useCustomParamId } from 'hooks/useParamId';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import {
  useGetMusicProductDigitalAssetId,
  usePostMusicProductDigitalAssetIdsAutoAssign,
} from 'services/music-product-digital/assetId';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const MusicProductDigitalAssetIds = () => {
  const productId = useCustomParamId('id', '/music-product-digital');

  const { t } = useTranslation();

  const assets = useGetMusicProductDigitalAssetId(productId);
  const autoAssignAssetIds = usePostMusicProductDigitalAssetIdsAutoAssign();

  const onCopySmartLink = (value?: string | null | undefined) => {
    if (value) {
      navigator.clipboard.writeText(value);
      toast.success(
        t('toast-message.copied-what', {
          what: value,
        }),
        { id: value }
      );
    }
  };

  return assets.isLoading ? (
    <Table
      id={'MusicProductDigitalTrackAssets'}
      size='compact'
      loading
      data={{
        nodes: [],
      }}
      columns={[
        {
          label: '',
          renderCell: () => null,
        },
      ]}
    />
  ) : (
    <div className='flex w-full flex-col gap-4'>
      <TopBar
        size='compact'
        hideHeader
        topbarContent={
          <Button
            isLoading={autoAssignAssetIds.isPending}
            onClick={async () =>
              await autoAssignAssetIds.mutateAsync(
                { musicProductDigitalId: productId },
                {
                  onSuccess: () => assets.refetch(),
                  onError: error => onErrorShowAllErrorsToast(error),
                }
              )
            }>
            <Button.Text text={t('button.request-asset-id')} />
          </Button>
        }
      />
      {assets.data?.map(track => (
        <Table
          id={'MusicProductDigitalTrackAssets'}
          size='compact'
          displayMode
          data={{
            nodes: track.assetIds.map((asset, index) => ({
              asset: asset,
              id: index,
            })),
          }}
          columns={[
            {
              label: `${track.title} ${
                track.titleVersion ? ` - ${track.titleVersion}` : ''
              }`,
              renderCell: ({ asset }) => (
                <TableItem>
                  <TableItem.Text text={asset} onClick={() => onCopySmartLink(asset)} />
                </TableItem>
              ),
            },
          ]}
        />
      ))}
    </div>
  );
};

export default MusicProductDigitalAssetIds;
